module.exports = __webpack_public_path__ + "img/orange_023.5df9bcdc.png";